import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, BookOpen } from 'lucide-react';
const chaptersData = [{
  emoji: '🚨',
  title: 'Capítulo 1 · Atención inicial del politraumatizado',
  items: ['ABCDE en trauma', 'Mecanismo de lesión', 'Inmovilización prehospitalaria', 'Síndrome compartimental agudo', 'Transfusión masiva (1:1:1)', 'Lectura de radiografías en trauma', 'Criterios de derivación urgente']
}, {
  emoji: '💪',
  title: 'Capítulo 2 · Fracturas de miembro superior',
  items: ['Clavícula y húmero proximal', 'Húmero diafisario', 'Codo (supracondílea, Gartland)', 'Antebrazo (Monteggia, Galeazzi)', 'Muñeca (Colles, Smith, escafoides)', 'Mano (Bennett, Rolando, falanges)']
}, {
  emoji: '🦵',
  title: 'Capítulo 3 · Fracturas de miembro inferior, pelvis y columna',
  items: ['Cadera (Garden)', 'Fémur diafisario y embolia grasa', 'Rodilla (Schatzker, rótula)', 'Tobillo (Lauge-Hansen)', 'Pie (Lisfranc, calcáneo, Ottawa)', 'Pelvis (Tile/Young-Burgess)', 'Columna cervical y ASIA']
}, {
  emoji: '⚠️',
  title: 'Capítulo 4 · Luxaciones urgentes',
  items: ['Hombro anterior (Stimson, Cunningham, Milch)', 'Codo (terrible tríada)', 'Cadera (Allis)', 'Rodilla (lesión vascular poplítea)', 'Tobillo y pie']
}, {
  emoji: '🩸',
  title: 'Capítulo 5 · Trauma abierto y partes blandas',
  items: ['Fractura expuesta (Gustilo-Anderson)', 'Lavado y desbridamiento', 'Amputaciones (Tamai)', 'Lesiones tendinosas y nerviosas', 'Aplastamiento y rabdomiólisis', 'Fasciotomía de emergencia']
}, {
  emoji: '🦠',
  title: 'Capítulo 6 · Emergencias infecciosas y patología aguda del hueso',
  items: ['Artritis séptica', 'Osteomielitis aguda', 'Fascitis necrotizante', 'Fractura patológica']
}, {
  emoji: '🛠️',
  title: 'Capítulo 7 · Procedimientos y referencias rápidas',
  items: ['Inmovilizaciones y férulas', 'Tracción cutánea y esquelética', 'Artrocentesis', 'Bloqueos anestésicos básicos', 'Tabla de analgésicos y antibióticos', 'Escalas de bolsillo (VAS, ASIA, Garden, Gustilo, Tile, Schatzker)']
}];
export function Chapters() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-pastel-50 px-4" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <div className="inline-flex items-center justify-center p-3 bg-navy-800 text-white rounded-full mb-4" data-id="element-30">
            <BookOpen size={24} data-id="element-31" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-32">
            📚 El temario más completo para tu R1
          </h2>
          <p className="text-navy-700" data-id="element-33">
            Todo lo que necesitas saber, organizado para consulta rápida en la
            guardia.
          </p>
        </div>

        <div className="space-y-3" data-id="element-34">
          {chaptersData.map((chapter, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className={`rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all border-2 ${isOpen ? 'bg-navy-800 border-navy-800' : 'bg-white border-pastel-200'}`} data-id="element-35">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-36">
                  <span className="flex items-center gap-3 pr-4" data-id="element-37">
                    <span className={`text-2xl transition-all ${isOpen ? '' : ''}`} data-id="element-38">
                      {chapter.emoji}
                    </span>
                    <span className={`font-bold transition-colors ${isOpen ? 'text-white' : 'text-navy-900'}`} data-id="element-39">
                      {chapter.title}
                    </span>
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className={`shrink-0 transition-colors ${isOpen ? 'text-white' : 'text-navy-500'}`} data-id="element-40">
                    <ChevronDown size={20} data-id="element-41" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-42">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-43">
                      <div className="px-5 pb-5 pt-1 border-t border-navy-700" data-id="element-44">
                        <ul className="space-y-2 mt-3" data-id="element-45">
                          {chapter.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-pastel-100 text-sm" data-id="element-46">
                              <span className="text-gold-400 mt-0.5" data-id="element-47">✓</span>
                              <span data-id="element-48">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}